<template>
    <!-- 编辑官网管理 -->
    <div class="insRegistrationView">
        <div class="search_container">
            <el-form size="mini" ref="form" class="searchBox" :inline="true" :model="orgData">
                <el-form-item label="赛项">
                    <el-select v-model="orgData.sysId" size="mini" filterable @change="getRegWebsiteManagement(1)" clearable
                         placeholder="请选择注册通道" style="width: 300px;">
                        <el-option v-for="ele in passagelist" :key="ele.id" :label="ele.passageName" :value="ele.id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <el-button size="mini" type="primary" @click="getRegWebsiteManagement(1)">查询</el-button>
            <!-- <div class="btnBox">
                <el-button type="primary" size="mini">批量通过</el-button>
                <el-button type="primary" size="mini">批量驳回</el-button>
            </div> -->
        </div>
        <div class="comPractice_container">
            <basic-table v-loading="loading" :isCheckbox='true' ref="RegWebsiteManagementTable" :tableHeader="RegWebsiteManagementHeader" :tableData="tableData" @operation="operation">
                <!-- eslint-disable-next-line vue/no-unused-vars -->
                <template slot-scope="data">
                    <el-button size="mini" @click="editBtn(data.row)" type="text">编辑</el-button>
                    <el-button size="mini" v-if="data.row.isStatus == 0" @click="openAndClosePlan(data.row, 1)" type="text">开启</el-button>
                    <el-button size="mini" v-else @click="openAndClosePlan(data.row, 0)" type="text">关闭</el-button>
                </template>
            </basic-table>
            <!-- <pagination :total="total" :limit.sync="limitSize" :page.sync="pageNo" @currentChange="currentChange"></pagination> -->
        </div>
        <examDialog :dialogVisible="dialogVisible" :rowData="rowData" @changeDialogVisible="changeDialogVisible"></examDialog>
    </div>
</template>

<script>
import { RegWebsiteManagementHeader } from './globalData'
import fetch from '@/api/fetch'
export default {
    name: 'RegWebsiteManagement',

    data() {
        return {
            dialogVisible: false,
            RegWebsiteManagementHeader,
            loading: false,
            total: 15,
            limitSize: 15,
            pageNo: 1,
            tableData: [],
            provinceData:[],
            orgData: {
                sysId: ''
            },
            passagelist:[],
            rowData: {}
        };
    },

    mounted() {
        // this.getProvinceList()
        this.getpassagelist()
        this.getRegWebsiteManagement()
    },


    methods: {
        getpassagelist() {
            fetch.getpassagelist().then(res => {
                if(res.code == '0') {
                    this.passagelist = res.data
                }
            })
        },
        editBtn(data) {
            this.dialogVisible = true
            this.rowData = data
        },
        openAndClosePlan(rowData, type) {
            fetch.openAndClosePlan({
                sysType: rowData.sysType,
                status: type
            }).then(res => {
                if(res.code == '0') {
                    this.$message.success(res.msg)
                    this.getRegWebsiteManagement()
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        changeDialogVisible(val) {
            this.dialogVisible = val
        },
        currentChange(val) {
            this.limitSize = val.limit
            this.pageNo = val.page
            this.getRegWebsiteManagement(this.pageNo)
        },
        operation() {},
        getRegWebsiteManagement() {
            let isStatusList = {
                0: '关闭',
                1: '开启'
            }
            let packetEntryList = {
                0: '学生组',
                1: '职工组',
                2: '高职组',
                3: '本科组'
            }
            fetch.getMatchtypelist({
                sysType: this.orgData.sysId
            }).then(res => {
                if(res.code == '0') {
                    this.tableData = res.data.map(item => {
                        return {...item , packetEntryText: packetEntryList[item.packetEntry],isStatusText:isStatusList[item.isStatus], }
                    })
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        getProvinceList() { // 省份下拉
            fetch.getProvinceList().then(res => {
                if (res.code == '0') {
                    this.provinceData = res.data
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        
    },
    components: {
        BasicTable: () => import('@/components/basicTable.vue'),
        // Pagination: () => import('@/components/pagination.vue'),
        examDialog: () => import('./components/examDialog.vue')
    }
};
</script>

<style lang="scss" scoped>
.insRegistrationView {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    .search_container {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
        height: 60px;
        background-color: #fff;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
        padding-left: 20px;
        box-sizing: border-box;
        .btnBox {
            width: 55%;
            text-align: right;
        }
    }
    .comPractice_container {
        width: 100%;
        height: calc(100% - 80px);
        background-color: #fff;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
        padding: 10px 20px 20px 20px;
        box-sizing: border-box;
    }
    .button_box {
        display: flex;
        height: 60px;
        justify-content: flex-end;
        align-items: center;
    }
    .searchBox {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        /deep/.el-form-item {
            margin-bottom: 0;
        }
    }
    .mySelect {
        /deep/.el-select {
            /deep/.el-input {
                width: 100px;
            }
        }
    }
    .addPlanDialog {
        /deep/.el-dialog__footer {
            text-align: center;
        }
        /deep/.el-dialog__header {
            border-bottom: 1px solid #ccc;
        }
        /deep/ .el-dialog__title {
            font-size: 14px;
        }
        .formcenter {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-bottom: 10px;
            /deep/.el-form-item {
                margin-bottom: 0;
            }
        }
        /deep/.el-checkbox {
            display: flex;
            align-items: center;
        }
        // .formLeft {
        //     padding-left: 17px;
        //     box-sizing: border-box;
        // }
        .mechanism {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 15px;
        }
        .mechanism_center {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .arrow_left {
                width: 30px;
                height: 30px;
                line-height: 30px;
                text-align: center;
                color: #fff;
                margin-bottom: 5px;
                background-color: #409eff;
                border-radius: 3px;
                cursor: pointer;
            }
            .arrow_right {
                width: 30px;
                height: 30px;
                color: #fff;
                margin-top: 5px;
                line-height: 30px;
                text-align: center;
                background-color: #409eff;
                border-radius: 3px;
                cursor: pointer;
            }
        }
        .mechanism_left {
            width: 45%;
            height: 350px;
            border: 1px solid #ccc;
        }
        .mechanism_right {
            width: 45%;
            height: 350px;
            border: 1px solid #ccc;
        }
        .mechanismToptitle {
            padding: 0 10px;
            box-sizing: border-box;
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            height: 50px;
            line-height: 50px;
            border-bottom: 1px solid #ccc;
            .left_box {
                display: flex;
                justify-content: flex-start;
                align-items: center;
            }
            .right_box {
                display: flex;
                justify-content: flex-start;
                align-items: center;
            }
        }
        .mechanismBottomMin {
            width: 100%;
            height: calc(100% - 50px);
        }
        .mechanismSearch {
            height: 40px;
            line-height: 40px;
            display: flex;
            justify-content: space-around;
            align-items: center;
        }
        .mechanismTable {
            padding: 0 10px 0px;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-content: space-around;
            width: 100%;
            height: calc(100% - 40px);
            overflow-x: hidden;
        }
        .mechanismTable2 {
            padding: 0 10px 0px;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-content: space-around;
            width: 100%;
            height: calc(100% - 40px);
            overflow-x: hidden;
        }
        .planInfo {
            padding: 0 30px;
            display: flex;
            flex-direction: column;
            align-content: space-around;
            color: #409eff;
            .planInfo_top {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                .left {
                    margin-right: 30px;
                }
            }
        }
        .mechanismOrgName {
            display: inline-block;
            width: 180px;
            height: 33px;
            line-height: 33px;
            overflow-x: hidden;
            overflow-y: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            padding-top: 1px;
            box-sizing: border-box;
        }
        .selectText {
            display: inline-block;
            width: 62px;
            height: 33px;
            line-height: 33px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            padding-top: 1px;
            box-sizing: border-box;
        }
        .selectText2 {
            display: inline-block;
            width: 50px;
            height: 33px;
            line-height: 33px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            padding-top: 1px;
            box-sizing: border-box;
        }
    }
    .editDialog {
        /deep/.el-dialog__footer {
            text-align: center;
        }
        /deep/.el-dialog__header {
            border-bottom: 1px solid #ccc;
        }
        /deep/ .el-dialog__title {
            font-size: 14px;
        }
        /deep/ .el-dialog__body {
            padding-left: 150px;
            padding-bottom: 0px;
        }
        .dialog_contenter {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-content: center;
        }
        .editCenterTwoBox {
            display: flex;
            justify-content: flex-start;
        }
    }
    .accountDialog {
        /deep/.el-dialog__footer {
            text-align: center;
        }
        /deep/.el-dialog__header {
            border-bottom: 1px solid #ccc;
        }
        /deep/ .el-dialog__title {
            font-size: 14px;
        }
        .dialog_contenter {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-content: center;
        }
        .reason {
            margin-bottom: 10px;
            color: #409eff;
        }
    }
    .basicTable {
        margin-top: 10px;
        height: 300px;
    }
}
</style>